import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Logo from "../../../assets/triangle.png";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";

const muiTheme = createTheme({
    palette: {
        primary: {
            main: "#FF2E28",
        },
        secondary: {
            main: "#FFF",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: "montserratbold",
                    fontSize: '1rem',
                    padding: '10px 16px',
                    borderRadius: '4',
                },
            }
        }
    }
});

const useStyles = theme => ({
    panel: {
        zIndex: '999',
        width: '100%',
        minHeight: '100%',
        display: 'flex',

        [theme.breakpoints.up('md')]: {
        }
    },
    effect: {
        display: 'flex',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(90deg, #614F41, #181A17)',
    },
    effectLogo: {
        display: 'flex',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',

        [theme.breakpoints.up('md')]: {
            backgroundImage: 'url(' + Logo + ')',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '188px 160px',
            backgroundPosition: 'calc(50% + 491px) 50%',
        }
    },
    content: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%',
        height: '100%',
        flexDirection: 'column',

        [theme.breakpoints.up('md')]: {
            width: '982px',
        }
    },
    textContent: {
        padding: '46px 18px 30px 18px',

        [theme.breakpoints.up('md')]: {
            padding: '46px 170px 60px 170px',
        }
    },
    title: {
        fontFamily: 'Divona',
        fontSize: '2.7em',
        lineHeight: '1.2em',
        color: '#FFE0BD',
    },
    subtitle: {
        fontFamily: 'montserratbold',
        letterSpacing: '0.1em',
        margin: '12px 0',
        textTransform: 'uppercase',
        color: '#FFF',
    },
    text: {
        margin: '20px 0 20px 0',
        color: '#FFF',
        textAlign: 'center',

        "& table": {
            margin: '26px auto 26px auto',
            borderSpacing: '0',

            [theme.breakpoints.up('lg')]: {
                width: '580px',
            },
        },

        "& tbody tr:nth-child(odd)": {
            background: 'rgba(13, 13, 13, 0.2)',
        },

        "& th": {
            textAlign: 'left',
            fontFamily: 'montserratbold',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: '#FFF',
            padding: '15px 8px 15px 8px',

            [theme.breakpoints.up('md')]: {
                padding: '15px 20px 15px 20px',
            }
        },

        "& td": {
            textAlign: 'left',
            padding: '15px 8px 15px 8px',

            [theme.breakpoints.up('md')]: {
                padding: '15px 20px 15px 20px',
            },
        }
    },
    more: {
        margin: '12px 0',

        '& a': {
            padding: '2px 4px',
            fontFamily: 'montserratbold',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: '#FFF',
            textDecoration: 'none',
            background: 'linear-gradient(0, #614F41 50%, transparent 50%)',
        },
        '& a:hover': {
            background: 'none',
        }
    },
    btn: {
        margin: '26px 0 26px 0',
    },
    mobile: {
        display: 'block',

        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    desktop: {
        display: 'none',

        [theme.breakpoints.up('md')]: {
            display: 'block',
        },
    },
    logo: {
        width: '112px',
    }
});

class ClassesPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        const { classes } = this.props;
        let self = this;

        return (
            <ThemeProvider theme={muiTheme}>

            <div className={classes.panel}>
                <div className={classes.effect}>
                    <div className={classes.effectLogo}>

                    <div className={classes.content}>
                        <div className={classes.textContent}>
                            <div className={classes.title}>Wing Chun<br />Adult Classes</div>
                            <div className={classes.text}>

                                <table>
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>Class</th>
                                        <th>Time</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <th><span className={classes.mobile}>Tue</span><span className={classes.desktop}>Tuesday</span></th>
                                        <td>Drills<br/>General<br/>Chi Sau<br/>Advanced Levels</td>
                                        <td>5.30pm - 6:00pm<br/>6.00pm - 7:30pm<br/>7.30pm - 8:00pm<br/>8:00pm - 9:30pm</td>
                                    </tr>
                                    <tr>
                                        <th><span className={classes.mobile}>Wed</span><span className={classes.desktop}>Wednesday</span></th>
                                        <td>Forms/Chi Sau<br/>General</td>
                                        <td>10:00am - 10:30pm<br/>10:30am - 12:00pm</td>
                                    </tr>
                                    <tr>
                                        <th><span className={classes.mobile}>Thur</span><span className={classes.desktop}>Thursday</span></th>
                                        <td>Drills<br/>General<br/>Chi Sau<br/>Advanced Levels</td>
                                        <td>5.30pm - 6:00pm<br/>6.00pm - 7:30pm<br/>7.30pm - 8:00pm<br/>8:00pm - 9:30pm</td>
                                    </tr>
                                    <tr>
                                        <th><span className={classes.mobile}>Sat</span><span className={classes.desktop}>Saturday</span></th>
                                        <td>Chi Sau<br/>General<br/>General</td>
                                        <td>9:30am - 10:30am<br/>10:30am - 12:00pm<br />12:00pm - 1:30pm</td>
                                    </tr>
                                    </tbody>
                                </table>

                                <p>Sparring classes - we have 2 sparring classes a month for Grade 1 and above, one on a Tuesday and one on a Saturday.</p>

                                <div className={classes.btn}><Link to="/freelesson"><Button variant="contained">Join the club</Button></Link></div>

                                <div className={classes.more}><Link to="/dragonsclasses">Check kids Kung Fu classes</Link></div>
                            </div>

                        </div>
                    </div>

                    </div>
                </div>
            </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(ClassesPanel)